export const SET_ACCOUNT_LOADING = 'SET_ACCOUNT_LOADING'
export const SET_ACCOUNT_OVERVIEW = 'SET_ACCOUNT_OVERVIEW'
export const SET_AGENT_QUICK_STATS_PANELS = 'SET_AGENT_QUICK_STATS_PANELS'
export const SET_ACCOUNT_OVERVIEW_STRIPE_SELLER =
  'SET_ACCOUNT_OVERVIEW_STRIPE_SELLER'
